module.exports = __webpack_public_path__ + "img/payment_pages_active.ccf1dcbf.svg";